var ClientUsageReport = /** @class */ (function () {
    function ClientUsageReport(companyName, salesForceId, lastSend, e1040, e1041, e1065, e1120, e1120S, e1040NR, total1040, total1041, total1065, total1120, total1120S, total1040NR, total, columnType, isTestCompany, userName, userEmail) {
        this.CompanyName = companyName;
        this.SalesforceId = salesForceId;
        this.LastSend = lastSend;
        this.E1040 = e1040;
        this.E1041 = e1041;
        this.E1065 = e1065;
        this.E1120 = e1120;
        this.E1120S = e1120S;
        this.E1040NR = e1040NR;
        this.Total1040 = total1040;
        this.Total1041 = total1041;
        this.Total1065 = total1065;
        this.Total1120 = total1120;
        this.Total1120S = total1120S;
        this.Total1040NR = total1040NR;
        this.Total = total;
        this.ColumnType = columnType;
        this.IsTestCompany = isTestCompany;
        this.UserName = userName;
        this.UserEmail = userEmail;
    }
    return ClientUsageReport;
}());
export { ClientUsageReport };
export var ColumnType;
(function (ColumnType) {
    ColumnType[ColumnType["Normal"] = 0] = "Normal";
    ColumnType[ColumnType["PageFooter"] = 1] = "PageFooter";
    ColumnType[ColumnType["TableFooter"] = 2] = "TableFooter";
})(ColumnType || (ColumnType = {}));
